import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const photoDimensions = {
  height: 70,
  width: 105,
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: ${spacing.majorScale(1)}px;
`

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const PhotoContainer = styled.div`
  height: ${photoDimensions.height}px;
  margin-right: ${spacing.minorScale(3)}px;
  width: ${photoDimensions.width}px;
`

export const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
